import { RxFlowConsent as RxFlowConsentModel } from "@/api/generated/models";
import { AssistantClientEvent } from "@/api/model/Conversation";
import { useSendRxInput } from "@/api/mutations/conversation";
import { Button, YStack } from "@/components";
import { useCurrentConversationId } from "@/hooks/conversation";
import { useInfiniteMessages } from "@/hooks/useInfiniteMessages";
import { useRxQuestionnaireStore } from "@/store/rxQuestionnaire";
import { AssistantMessageTypes } from "@/types";

export interface RxFlowConsentProps extends AssistantClientEvent {
  content: RxFlowConsentModel;
  type: AssistantMessageTypes.RX_FLOW_CONSENT;
}

export default function RxFlowConsent({
  type,
  content,
  messageId,
}: RxFlowConsentProps) {
  const conversationId = useCurrentConversationId();
  // TODO: do we need to flex this based on type as well?
  const { sendRxInput } = useSendRxInput(conversationId);
  const { data: messagesData } = useInfiniteMessages(conversationId);
  const { open } = useRxQuestionnaireStore();

  const allMessages = messagesData?.allMessages || [];

  // Only render the latest rx_flow_consent or rx_renewal_flow_consent message
  const rxConsentMessages = allMessages.filter((msg) => msg.type === type);
  const latestRxConsent = rxConsentMessages[rxConsentMessages.length - 1];
  const isLatestConsent = latestRxConsent?.id === messageId;

  if (!isLatestConsent) {
    return null;
  }

  const hasQuestionnaireEnded = allMessages.some(
    (msg) => msg.type === "rx_questionnaire_end",
  );

  const hasRxQuestions = allMessages.some((msg) => msg.type === "rx_question");

  const handleConsent = () => {
    if (conversationId) {
      open(conversationId);
    }

    if (!hasRxQuestions) {
      sendRxInput("Yes");
    }
  };

  const buttonText = hasQuestionnaireEnded
    ? "Survey Completed"
    : hasRxQuestions
      ? "Continue survey"
      : "Continue";

  return (
    <YStack gap="$200">
      <Button
        mode="primary"
        onPress={hasQuestionnaireEnded ? undefined : handleConsent}
        disabled={hasQuestionnaireEnded}
      >
        {buttonText}
      </Button>
    </YStack>
  );
}
